import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_CONGNOTHANHLY } from "../actions/CongNoThanhLy/actionTypes";
import {
  getListCongNoThanhLySuccess,
  getListCongNoThanhLyFailure,
} from "../actions/CongNoThanhLy";
import CongNoThanhLyApi from "../service/congNoThanhLyApi";
import { pushNotification } from "utils/notifications";

function* getListCongNoThanhLy(action) {
  try {
    const response = yield call(CongNoThanhLyApi.list1, action.dataSearch);
    if (response.ok) {
      yield put(getListCongNoThanhLySuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListCongNoThanhLyFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListCongNoThanhLyFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CONGNOTHANHLY, getListCongNoThanhLy);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
